// Floater fale conosco
var FltFale;

(function($){

	FltFale = {

		$trigger : null,
		$all : null,
		$buts : null,
		$footer : null,
		timeClose : false,
		timeResize : false,
		window : false,

		init : function(){

			this.window = $( window );

            this.$trigger = $( 'button.fltfale' );
            if( !this.$trigger ) return true;

            this.$footer = $( '#main > footer' ).first();
            this.$all = $( 'button.fltfale,a.fltfale,i.fltfale' );
            this.$buts = this.$all.filter( 'a.fltfale,i.fltfale' );

            this.bind();
		
		},

		bind : function(){

            this.$trigger.on( 'click', function( e ){
                e.preventDefault();
                FltFale.toggle();
            });

            // timeClose
            FltFale.$all.hover(
                function(){
                    if( FltFale.timeClose ) clearTimeout( FltFale.timeClose );
                },
                function(){
                    if( FltFale.timeClose ) clearTimeout( FltFale.timeClose );
                    FltFale.timeClose = setTimeout(function(){
                        FltFale.closeLinks();
                    }, 3000 );
                }
            );

            // Scroll and Resize
            this.window.bind( 'resize', function(){
                if( FltFale.timeResize ) clearTimeout( FltFale.timeResize );
                FltFale.timeResize = setTimeout(function(){
                    FltFale.checkScroll();
                }, 100 );
            }).resize(); 
            this.window.scroll(function(){
                FltFale.checkScroll();
            });
            FltFale.checkScroll();

		},

		// Toggle button
		toggle : function(){
            if( this.$trigger.hasClass( 'opened' ) ){
            	this.closeLinks();
            }
            else {
            	this.openLinks();
            }
		},

		openLinks : function(){
            this.$trigger.addClass( 'opened' );
            this.$buts.fadeIn();
		},

		closeLinks : function(){
            this.$trigger.removeClass( 'opened' );
            this.$buts.fadeOut();
		},
        
        // Uncheck menu items when is top page
        checkScroll : function(){

            var scrollTop = this.window.scrollTop();     
            
            var 
                footerHeight = FltFale.$footer.outerHeight( true ),
                screenHeight = Math.max( document.documentElement.clientHeight, window.innerHeight || 0 ),
                scrollHeight = document.documentElement.scrollHeight,
                limitTop = scrollHeight - screenHeight - footerHeight
            ;
            if( scrollTop >= limitTop ){
                FltFale.$all.addClass( 'hidden' );
                FltFale.closeLinks();
            }
            else {
                FltFale.$all.removeClass( 'hidden' )
            }
        
        }

	};
	$(function(){
		FltFale.init();
	})

})(jQuery);